import React from 'react';
export const AuthorizeСar = React.lazy(() => import('./AuthorizeСar.js'));